// التطبيقات والواجهة البرمجية، والويب هوك، والتطبيقات المتصلة (المواصفات 30).
const appsAr = {
  "apps.title": "التطبيقات والواجهة البرمجية",
  "apps.nav_hint": "التطبيقات المخصصة، ورموز الوصول، والتطبيقات المتصلة، والويب هوك",
  "apps.description": "اربط نظام تخطيط الموارد أو المحاسبة أو تطبيق الجوال أو واجهة متجر مستقلة عبر واجهة الإدارة البرمجية وواجهة المتجر البرمجية والويب هوك.",
  "apps.create": "إنشاء تطبيق مخصص",
  "apps.edit": "تعديل",
  "apps.done": "تم",
  "apps.empty": "اربط برامجك الخاصة",
  "apps.empty_body": "يحصل التطبيق المخصص على رمز وصول لواجهة الإدارة البرمجية بالصلاحيات التي تختارها فقط. ألغِ تثبيته في أي وقت لقطع وصوله.",
  "apps.kind.custom": "تطبيق مخصص",
  "apps.kind.partner": "تطبيق متصل",
  "apps.status.active": "مثبّت",
  "apps.status.uninstalled": "أُلغي تثبيته",
  "apps.webhooks_count": "{count, plural, zero {لا ويب هوك} one {ويب هوك واحد} two {ويب هوك اثنان} few {# ويب هوك} many {# ويب هوك} other {# ويب هوك}}",
  "apps.scopes_count": "{count, plural, zero {دون صلاحيات} one {صلاحية واحدة} two {صلاحيتان} few {# صلاحيات} many {# صلاحية} other {# صلاحية}}",
  "apps.installed_on": "ثُبّت في {date}",
  "apps.developer": "المطوّر",
  "apps.developer_email": "بريد المطوّر",
  "apps.developer_email_hint": "نراسل هذا العنوان عندما يتعطل الويب هوك الخاص بالتطبيق ويتوقف.",
  "apps.name": "اسم التطبيق",
  "apps.api_version": "إصدار الواجهة البرمجية",
  "apps.api_version_hint": "تستخدم بيانات الويب هوك والردود هذا الإصدار. يُدعم كل إصدار لمدة 12 شهراً على الأقل.",
  "apps.version_current": "{name} (الحالي)",
  "apps.version_sunset": "{name} (حتى {date})",
  "apps.access": "صلاحيات الواجهة البرمجية",
  "apps.access_hint": "امنح التطبيق ما يحتاجه فقط. صلاحية التعديل تشمل صلاحية العرض.",
  "apps.access.none": "بلا وصول",
  "apps.access.read": "عرض",
  "apps.access.write": "عرض وتعديل",
  "apps.special": "بيانات حساسة",
  "apps.scopes_readonly": "يحدد مطوّر التطبيق المتصل صلاحياته. أعد تثبيت التطبيق للموافقة على صلاحيات جديدة.",
  "apps.created": "أُنشئ التطبيق",
  "apps.saved": "حُفظ التطبيق",
  "apps.endpoints": "عناوين الواجهة البرمجية",
  "apps.admin_api": "واجهة الإدارة البرمجية",
  "apps.storefront_api": "واجهة المتجر البرمجية",
  "apps.openapi": "مستند OpenAPI",
  "apps.docs": "مرجع الواجهة البرمجية",
  "apps.endpoints_hint": "أرسل رمز الإدارة في الترويسة X-Sooquna-Access-Token، ورمز المتجر في X-Sooquna-Storefront-Access-Token.",

  "apps.tokens": "رموز الوصول",
  "apps.tokens_hint": "الرموز تستدعي الواجهة البرمجية ولا توقّع الويب هوك. رمز واجهة الإدارة يقرأ بيانات متجرك ويعدّلها، فاحفظه على خادم. أما رمز واجهة المتجر فيقرأ المنتجات المنشورة ويدير السلال فقط، لذا يمكن وضعه بأمان في متصفح أو تطبيق جوال.",
  "apps.token.admin": "واجهة الإدارة البرمجية",
  "apps.token.storefront": "واجهة المتجر البرمجية",
  "apps.token_revoked": "أُبطل في {date}",
  "apps.token_last_used": "آخر استخدام {date}",
  "apps.token_never_used": "لم يُستخدم بعد",
  "apps.rotate_admin": "تجديد رمز الإدارة",
  "apps.rotate_admin_body": "يُنشأ رمز جديد ويتوقف الرمز الحالي فوراً. حدّث التطبيق بالرمز الجديد.",
  "apps.add_storefront": "إنشاء رمز للمتجر",
  "apps.revoke": "إبطال",
  "apps.revoke_title": "إبطال هذا الرمز؟",
  "apps.revoke_body": "تُرفض الطلبات بهذا الرمز فوراً، ولا يمكن التراجع عن ذلك.",
  "apps.revoked": "أُبطل الرمز",
  "apps.token_title": "انسخ رمز الوصول",
  "apps.token_once": "انسخه الآن واحفظه في مكان آمن. حفاظاً على أمانك لن تراه مرة أخرى.",
  "apps.copied": "نُسخ",

  "apps.credentials": "بيانات اعتماد العميل",
  "apps.credentials_hint": "يوقّع سرّ العميل الويب هوك الخاص بالتطبيق (X-Sooquna-Hmac-Sha256). تحقّق من التوقيع قبل الوثوق بأي ويب هوك.",
  "apps.client_id": "معرّف العميل",
  "apps.client_secret": "سرّ العميل",
  "apps.reveal": "إظهار",
  "apps.rotate_secret": "تجديد السرّ",
  "apps.rotate_secret_body": "يُنشأ سرّ جديد يوقّع الويب هوك من الآن. حدّث التطبيق قبل وصول الويب هوك التالي.",
  "apps.hidden": "مخفي",

  "apps.usage": "طلبات الواجهة البرمجية في آخر 30 يوماً",
  "apps.usage_requests": "الطلبات",
  "apps.usage_errors": "{count, plural, one {طلب واحد فشل} two {طلبان فشلا} few {# طلبات فشلت} many {# طلباً فشل} other {# طلب فشل}} خلال 30 يوماً",
  "apps.usage_none": "لا طلبات بعد.",

  "apps.uninstall": "إلغاء تثبيت التطبيق",
  "apps.uninstall_title": "إلغاء تثبيت {name}؟",
  "apps.uninstall_body": "تتوقف رموزه فوراً ويُوقف الويب هوك الخاص به. يتلقى التطبيق ويب هوك أخيراً app/uninstalled.",
  "apps.uninstalled": "أُلغي تثبيت التطبيق",
  "apps.uninstalled_banner": "أُلغي تثبيت هذا التطبيق في {date}. لم تعد رموزه ولا الويب هوك الخاص به تعمل.",

  "apps.scope.products": "المنتجات",
  "apps.scope.inventory": "المخزون",
  "apps.scope.locations": "المواقع",
  "apps.scope.customers": "العملاء",
  "apps.scope.orders": "الطلبات",
  "apps.scope.draft_orders": "مسودات الطلبات",
  "apps.scope.fulfillments": "التجهيز والشحن",
  "apps.scope.returns": "المرتجعات",
  "apps.scope.discounts": "الخصومات",
  "apps.scope.gift_cards": "بطاقات الهدايا",
  "apps.scope.content": "محتوى المتجر",
  "apps.scope.themes": "القوالب",
  "apps.scope.files": "الملفات",
  "apps.scope.markets": "الأسواق",
  "apps.scope.translations": "الترجمات",
  "apps.scope.reports": "التقارير",
  "apps.scope.shipping": "الشحن",
  "apps.scope.metaobjects": "البيانات المخصصة",
  "apps.scope.all_orders": "كل الطلبات",
  "apps.scope.customer_pii": "بيانات تواصل العملاء",
  "apps.scope_desc.products": "المنتجات والأنواع والمجموعات وتصنيف المنتجات.",
  "apps.scope_desc.inventory": "مستويات المخزون والتعديلات والتحويلات والموردون وأوامر الشراء.",
  "apps.scope_desc.locations": "المستودعات والمحلات ونقاط الاستلام.",
  "apps.scope_desc.customers": "العملاء وعناوينهم وشرائحهم. تتطلب بيانات التواصل صلاحية بيانات تواصل العملاء.",
  "apps.scope_desc.orders": "الطلبات والمعاملات والمبالغ المستردة وعمليات الدفع المتروكة خلال آخر 60 يوماً.",
  "apps.scope_desc.draft_orders": "مسودات الطلبات.",
  "apps.scope_desc.fulfillments": "أوامر التجهيز والشحنات وملصقات الشحن والتتبع.",
  "apps.scope_desc.returns": "طلبات الإرجاع.",
  "apps.scope_desc.discounts": "الخصومات وأكواد الخصم.",
  "apps.scope_desc.gift_cards": "بطاقات الهدايا وأرصدتها.",
  "apps.scope_desc.content": "الصفحات والمدونات والمقالات والقوائم وإعادات التوجيه والسياسات.",
  "apps.scope_desc.themes": "القوالب وملفاتها.",
  "apps.scope_desc.files": "الملفات والمرفوعات.",
  "apps.scope_desc.markets": "الأسواق وعملاتها ولغاتها ونطاقاتها.",
  "apps.scope_desc.translations": "اللغات والمحتوى المترجم.",
  "apps.scope_desc.reports": "تقارير التحليلات.",
  "apps.scope_desc.shipping": "ملفات الشحن والمناطق والأسعار والتوصيل المحلي والاستلام.",
  "apps.scope_desc.metaobjects": "الحقول الوصفية وتعريفاتها والكائنات الوصفية.",
  "apps.scope_desc.all_orders": "الطلبات الأقدم من 60 يوماً.",
  "apps.scope_desc.customer_pii": "أسماء العملاء وبريدهم الإلكتروني وأرقام هواتفهم وعناوينهم.",

  "wh.title": "الويب هوك",
  "wh.app_hint": "أرسل الأحداث إلى التطبيق فور وقوعها. يُوقَّع كل طلب بسرّ العميل الخاص بالتطبيق.",
  "wh.store_hint": "أرسل أحداث المتجر إلى أنظمتك فور وقوعها. يُوقَّع كل طلب بالمفتاح أدناه.",
  "wh.add": "إضافة ويب هوك",
  "wh.edit": "تعديل الويب هوك",
  "wh.empty": "لا يوجد ويب هوك بعد.",
  "wh.topic": "الحدث",
  "wh.endpoint": "الرابط",
  "wh.endpoint_hint": "عنوان https:// على الإنترنت العام، ويجب أن يرد خلال 5 ثوانٍ برمز حالة 2xx.",
  "wh.fields": "الحقول",
  "wh.fields_hint": "أرسل هذه الحقول العليا فقط، مفصولة بفواصل. اتركه فارغاً لإرسال كل شيء.",
  "wh.namespaces": "نطاقات الحقول الوصفية",
  "wh.namespaces_hint": "ضمّن الحقول الوصفية في هذه النطاقات، مفصولة بفواصل.",
  "wh.status.active": "نشط",
  "wh.status.disabled": "متوقف",
  "wh.failing_since": "أول فشل {date}",
  "wh.disabled_hint": "توقف في {date} بعد فشله لمدة 48 ساعة. أصلح الرابط ثم أعد تشغيله.",
  "wh.enable": "تشغيل",
  "wh.disable": "إيقاف",
  "wh.test": "إرسال تجريبي",
  "wh.test_sent": "أُرسل الاختبار: {status}",
  "wh.test_failed": "فشل الإرسال: {error}",
  "wh.deliveries": "عمليات الإرسال الأخيرة",
  "wh.delete_title": "حذف هذا الويب هوك؟",
  "wh.delete_body": "سيتوقف إرسال الأحداث إلى {endpoint}.",
  "wh.deleted": "حُذف الويب هوك",
  "wh.saved": "حُفظ الويب هوك",
  "wh.of_app": "من {app}",
  "wh.log_empty": "لا عمليات إرسال خلال آخر 30 يوماً.",
  "wh.log_hint": "تُحفظ عمليات الإرسال 30 يوماً، ويُعاد إرسال ما فشل منها لمدة 48 ساعة.",
  "wh.attempt": "المحاولة {n}",
  "wh.manual": "يدوي",
  "wh.no_response": "لا رد",
  "wh.request": "الطلب",
  "wh.response": "الرد",
  "wh.resend": "إعادة الإرسال",
  "wh.resent": "أُعيد الإرسال: {status}",
  "wh.latency": "{ms} ملّي ثانية",

  "install.title": "تثبيت تطبيق",
  "install.choose_store": "اختر المتجر الذي تريد تثبيت التطبيق عليه",
  "install.no_stores": "لا تدير أي متجر يمكنك تثبيت التطبيقات عليه.",
  "install.wants": "يريد {name} الوصول إلى متجرك",
  "install.by": "من تطوير {email}",
  "install.access": "سيتمكن من:",
  "install.read": "عرض {resource}",
  "install.write": "عرض {resource} وتعديلها",
  "install.reinstall": "التطبيق مثبّت. التثبيت مرة أخرى يحدّث صلاحياته.",
  "install.cancel": "إلغاء",
  "install.install": "تثبيت التطبيق",
  "install.invalid": "رابط التثبيت هذا غير صالح. اطلب رابطاً جديداً من مطوّر التطبيق.",
  "install.redirecting": "جارٍ التثبيت… ستعود إلى التطبيق خلال لحظات.",

  "papps.title": "التطبيقات المتصلة",
  "papps.hint": "أنشئ تطبيقات يثبّتها التجار من رابط التثبيت الخاص بك (OAuth). يحصل كل تثبيت على رمز وصول خاص به.",
  "papps.pending": "تتوفر التطبيقات المتصلة بعد اعتماد حساب الشريك.",
  "papps.create": "إنشاء تطبيق",
  "papps.edit": "تعديل التطبيق",
  "papps.app_url": "رابط التطبيق",
  "papps.redirect_urls": "روابط إعادة التوجيه المسموحة",
  "papps.redirect_hint": "رابط https:// واحد في كل سطر. بعد أن يثبّت التاجر التطبيق نوجّهه إلى أحدها مع رمز التفويض.",
  "papps.installs": "{count, plural, zero {لا تثبيتات} one {تثبيت واحد} two {تثبيتان} few {# تثبيتات} many {# تثبيتاً} other {# تثبيت}}",
  "papps.install_url": "رابط التثبيت",
  "papps.secret_title": "سرّ العميل",
  "papps.secret_once": "انسخه الآن. يستبدل تطبيقك رموز التفويض بمعرّف العميل وهذا السرّ على {url}.",
  "papps.rotate_secret": "تجديد السرّ",
  "papps.delete_title": "حذف {name}؟",
  "papps.delete_body": "سيتوقف رابط التثبيت عن العمل. لا يمكن حذف تطبيق ما زالت متاجر تستخدمه.",
  "papps.deleted": "حُذف التطبيق",

  "apps.hide": "إخفاء",
  "apps.view": "عرض",
  "apps.last_30": "آخر 30 يوماً",
  "apps.more": "إجراءات أخرى",
  "apps.token_admin_use": "أرسله في الترويسة X-Sooquna-Access-Token من خادمك. لا تضعه أبداً في متصفح أو تطبيق جوال.",
  "apps.token_storefront_use": "أرسله في الترويسة X-Sooquna-Storefront-Access-Token. يمكن وضعه بأمان في متصفح أو تطبيق جوال.",
  "apps.token_saved": "حفظته",
  "apps.access_more": "{first} و{count, plural, zero {# أخرى} one {واحد آخر} two {اثنان آخران} few {# أخرى} many {# أخرى} other {# أخرى}}",
  "apps.list_sep": "، ",
  "apps.admin_access": "صلاحيات واجهة الإدارة البرمجية",
  "apps.admin_api_hint": "اقرأ بيانات المتجر وعدّلها من خادمك.",
  "apps.storefront_api_hint": "المنتجات المنشورة والسلال وحسابات العملاء لواجهات المتجر المستقلة وتطبيقات الجوال.",
  "apps.openapi_hint": "استورده في Postman أو Insomnia أو أداة توليد الشيفرة.",
  "apps.client_id_hint": "يعرّف التطبيق.",
  "apps.client_secret_hint": "وهو أيضاً مفتاح توقيع الويب هوك لهذا التطبيق. احفظه على خادمك.",
  "apps.col.app": "التطبيق",
  "apps.col.access": "الصلاحيات",
  "apps.col.webhooks": "الويب هوك",
  "apps.col.installed": "تاريخ التثبيت",
  "apps.col.status": "الحالة",
  "apps.col.token": "الرمز",
  "apps.col.created": "تاريخ الإنشاء",
  "apps.col.last_used": "آخر استخدام",
  "apps.configure": "ضبط الصلاحيات",
  "apps.create_action": "إنشاء التطبيق",
  "apps.create_hint": "التطبيقات المخصصة تُبنى لهذا المتجر وحده، بواسطتك أو بواسطة مطوّر تثق به. بعد إنشاء التطبيق اختر الصلاحيات التي يحصل عليها.",
  "apps.details": "تفاصيل التطبيق",
  "apps.granted": "{count, plural, zero {لا شيء} one {واحدة ممنوحة} two {اثنتان ممنوحتان} few {# ممنوحة} many {# ممنوحة} other {# ممنوحة}}",
  "apps.name_hint": "يظهر في سجل النشاط بجانب كل ما يفعله التطبيق.",
  "apps.name_placeholder": "مثلاً: مزامنة نظام الموارد",
  "apps.no_access": "دون صلاحيات بعد",
  "apps.no_access_yet": "لا يستطيع هذا التطبيق قراءة أي شيء أو تعديله بعد. اختر ما يمكنه الوصول إليه.",
  "apps.no_tokens": "لا رموز نشطة.",
  "apps.secret_rotated": "جُدّد سرّ العميل",
  "apps.special_hint": "تبقى متوقفة ما لم يحتجها التطبيق فعلاً. تظهر لك كل واحدة في سجل النشاط.",
  "apps.stat.requests": "طلبات الواجهة البرمجية",
  "apps.stat.failed": "الطلبات الفاشلة",
  "apps.stat.rate": "{pct}٪ من الطلبات",
  "apps.stat.last_used": "آخر استخدام",
  "apps.stat.webhooks": "الويب هوك",
  "apps.version_latest": "أحدث إصدار",
  "apps.version_until": "مدعوم حتى {date}",
  "apps.tab.overview": "نظرة عامة",
  "apps.tab.configuration": "الإعداد",
  "apps.tab.credentials": "بيانات اعتماد الواجهة",
  "apps.tab.webhooks": "الويب هوك",
  "apps.group.catalog": "الكتالوج",
  "apps.group.orders": "الطلبات والتجهيز",
  "apps.group.customers": "العملاء",
  "apps.group.marketing": "التسويق",
  "apps.group.store": "المتجر الإلكتروني",
  "apps.group.analytics": "التحليلات",
  "wh.actions": "إجراءات",
  "wh.advanced": "خيارات متقدمة",
  "wh.delivered": "أُرسل",
  "wh.failed": "فشل",
  "wh.disabled_on": "توقف في {date}",
  "wh.empty_body": "أرسل أحداثاً مثل الطلبات الجديدة أو تغيّر المخزون إلى أنظمتك لحظة وقوعها.",
  "wh.group.store": "المتجر",
  "wh.key_created_on": "أُنشئ في {date}",
  "wh.key_rotated": "جُدّد مفتاح التوقيع",
  "wh.key_rotated_on": "جُدّد في {date}",
  "wh.rotate": "تجديد المفتاح",
  "wh.rotate_title": "تجديد مفتاح التوقيع؟",
  "wh.rotate_body": "يُوقَّع كل ويب هوك من الآن، بما في ذلك إعادات المحاولة، بالمفتاح الجديد. حدّث أنظمتك فوراً وإلا سترفض الويب هوك.",
  "wh.search_topics": "ابحث في الأحداث",
  "wh.status": "الحالة",
  "wh.status.failing": "يفشل",
  "wh.topic_hint": "نرسل ويب هوك في كل مرة يحدث فيها هذا.",
  "wh.verify_docs": "كيف تتحقق من الويب هوك",
  "wh.version_hint": "تستخدم البيانات هذا الإصدار.",
  "wh.t.app/uninstalled": "إلغاء تثبيت التطبيق",
  "wh.t.shop/update": "تحديث بيانات المتجر",
  "wh.t.products/create": "إنشاء منتج",
  "wh.t.products/update": "تحديث منتج",
  "wh.t.products/delete": "حذف منتج",
  "wh.t.collections/create": "إنشاء مجموعة",
  "wh.t.collections/update": "تحديث مجموعة",
  "wh.t.collections/delete": "حذف مجموعة",
  "wh.t.inventory_levels/update": "تحديث مستوى المخزون",
  "wh.t.inventory_items/update": "تحديث عنصر المخزون",
  "wh.t.locations/create": "إنشاء موقع",
  "wh.t.locations/update": "تحديث موقع",
  "wh.t.locations/delete": "حذف موقع",
  "wh.t.customers/create": "إنشاء عميل",
  "wh.t.customers/update": "تحديث عميل",
  "wh.t.customers/delete": "حذف عميل",
  "wh.t.customers/redact": "مسح بيانات عميل",
  "wh.t.customers/data_request": "طلب بيانات عميل",
  "wh.t.orders/create": "إنشاء طلب",
  "wh.t.orders/updated": "تحديث طلب",
  "wh.t.orders/edited": "تعديل طلب",
  "wh.t.orders/paid": "دفع طلب",
  "wh.t.orders/cancelled": "إلغاء طلب",
  "wh.t.orders/fulfilled": "تجهيز طلب",
  "wh.t.orders/partially_fulfilled": "تجهيز جزئي لطلب",
  "wh.t.order_transactions/create": "إنشاء معاملة طلب",
  "wh.t.refunds/create": "إنشاء استرداد",
  "wh.t.fulfillments/create": "إنشاء شحنة",
  "wh.t.fulfillments/update": "تحديث شحنة",
  "wh.t.fulfillment_events/create": "تحديث التتبع",
  "wh.t.returns/request": "طلب إرجاع",
  "wh.t.returns/update": "تحديث إرجاع",
  "wh.t.draft_orders/create": "إنشاء مسودة طلب",
  "wh.t.draft_orders/update": "تحديث مسودة طلب",
  "wh.t.draft_orders/delete": "حذف مسودة طلب",
  "wh.t.checkouts/create": "بدء عملية دفع",
  "wh.t.checkouts/update": "تحديث عملية دفع",
  "wh.t.carts/update": "تحديث سلة",
  "wh.t.discounts/create": "إنشاء خصم",
  "wh.t.discounts/update": "تحديث خصم",
  "wh.t.discounts/delete": "حذف خصم",
  "wh.t.gift_cards/create": "إنشاء بطاقة هدية",
  "wh.t.gift_cards/update": "تحديث بطاقة هدية",
  "wh.t.themes/publish": "نشر قالب",
  "wh.t.themes/update": "تحديث قالب",
  "wh.t.themes/delete": "حذف قالب",
  "wh.t.domains/create": "إضافة نطاق",
  "wh.t.domains/update": "تحديث نطاق",
  "wh.t.domains/destroy": "إزالة نطاق",
  "wh.key_title": "مفتاح توقيع الويب هوك",
  "wh.key_store_body": "يُوقَّع كل ويب هوك أعلاه بهذا المفتاح. استخدمه للتحقق من الترويسة X-Sooquna-Hmac-Sha256 في كل طلب. هو للتحقق من الويب هوك فقط: ليس رمز وصول ولا يمكنه استدعاء الواجهة البرمجية.",
  "wh.key_app_body": "يُوقَّع الويب هوك الخاص بهذا التطبيق بسرّ العميل، لذا فسرّ العميل هو المفتاح الذي تتحقق به من الترويسة X-Sooquna-Hmac-Sha256. رموز الوصول لا توقّع الويب هوك.",
  "wh.key_partner_body": "يُوقَّع بسرّ العميل الخاص بـ {app}، ولا يملكه إلا مطوّره. يتحقق التطبيق من التوقيعات بنفسه، فلا مفتاح عليك إعداده.",
  "wh.key_rotate_in_credentials": "جدّده من بيانات اعتماد الواجهة",
};

export default appsAr;
